// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { check16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-check': IconCheck;
    }
}

/**
 * The icon component for the 'check' icon
 */
export class IconCheck extends Icon {
    public constructor() {
        super(check16X16);
    }
}

registerIcon('icon-check', IconCheck);
export const iconCheckTag = 'nimble-icon-check';
